export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./RegisterPage.vue?vue&type=template&id=0f2cf926&"


//////////////////
// WEBPACK FOOTER
// ./src/views/RegisterPage.vue?vue&type=template&id=0f2cf926&
// module id = 914
// module chunks = 0